import { SignJWT } from 'jose';

import { config } from '@/config';

/**
 * Mints a locally signed HS256 token that the API accepts when its own
 * TEST_LOGIN_ENABLED is set. This exists so the e2e suite exercises the real
 * backend without depending on the TimeLog login portal being reachable.
 *
 * Mirrors `Web/src/auth/testLogin/createTestUser.ts`. MUST NOT be enabled in any
 * deployed environment — see docs/adr/0004-oidc-auth-via-timelog-login-portal.md.
 */
export type TestIdentity = {
  siteName: string;
  userId: string;
  tenantId: string;
  displayName: string;
};

export const DEFAULT_TEST_IDENTITY: TestIdentity = {
  siteName: 'testsite',
  userId: '1',
  tenantId: '1000',
  displayName: 'Local Test User',
};

export const createTestToken = async (
  identity: TestIdentity = DEFAULT_TEST_IDENTITY,
): Promise<string> => {
  if (!config.testLoginSecret) {
    throw new Error('Test login is enabled but VITE_TEST_LOGIN_SECRET is not set');
  }

  return new SignJWT({ name: identity.displayName })
    .setProtectedHeader({ alg: 'HS256' })
    .setSubject(`${identity.siteName}:${identity.userId}:${identity.tenantId}`)
    .setIssuer(config.loginPortal)
    .setAudience(config.oidcAudience)
    .setIssuedAt()
    .setExpirationTime('8h')
    .sign(new TextEncoder().encode(config.testLoginSecret));
};
